import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrivacyRoutingModule } from './privacy-routing.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SupportComponent } from './support/support.component';

@NgModule({
  imports: [
    CommonModule,
    PrivacyRoutingModule
  ],
  declarations: [PrivacyPolicyComponent, SupportComponent]
})
export class PrivacyModule { }



// WEBPACK FOOTER //
// ./src/app/privacy/privacy.module.ts